import { Injectable, OnInit } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  private itemsPerPage = 5;
  private currentPage = 5;

  private notificationItems = [
    {
      "date": "12/08/2026",
      "title": "Alterações nos Formulários de Informações Trimestrais (ITR) e de Demonstrações Financeiras Padronizadas (DFP)",
      "preview": `A B3 e CVM informam que, a partir de 29/08/2026, os Formulários de Informações Trimestrais (ITR) e de Demonstrações Financeiras Padronizadas (DFP) passarão a apresentar novos campos de preenchimento obrigatório, na seção “Dados da Empresa”, denominados “Valor da Receita Bruta Consolidada Acumulada” e “Data”.
      <br><br> Dessa forma, para apresentações e reapresentações desses formulários, realizadas a partir, inclusive, de 29/08/2026, o não preenchimento desses campos será pendência impeditiva para o seu envio.
      <br><br> Qualquer dúvida, nossa Superintendência de Atendimento de Listados está à disposição para auxiliar, pelo telefone (11) 2565-5063 ou por e-mail: <a class=\"link-external-b3\" href=\"mailto:emissores.empresas@b3.com.br\">emissores.empresas@b3.com.br</a>
      <br><br> Até breve,
      <br><br> Equipe B3 – Portfolio de Emissores e Ofertas`,
      "expirationDate": "2026-09-30"
    },
    {
      "date": "12/08/2026",
      "title": "Relatório Lideranças Plurais 2026",
      "preview": `A B3 S.A – Brasil, Bolsa, Balcão lançou, em 12/08/2026, o relatório “Lideranças Plurais”, estudo que mapeia a diversidade na liderança das empresas listadas, com base na análise dos dados públicos divulgados no Formulário de Referência e em razão do Anexo ASG da B3.
      <br><br> <a class=\"link-external-b3\" href=\"https://www.b3.com.br/data/files/C6/16/57/A4/E56FF91094DCD8F9AC094EA8/Locomotiva_B3_Liderancas_Plurais_2026_v4_D%20_1_%201.pdf\" target=\"_blank\" rel=\"noopener noreferrer\"><b>Clique aqui e acesse</b></a>`,
      "expirationDate": "2026-09-30"
    },
    {
      "date": "03/09/2026",
      "title": "Novo quadro 6.1/2 do Formulário de Referência (FRe)",
      "preview": `A B3 e CVM informam que, a partir de 03/10/2026, o quadro 6.1/2 do Formulário de Referência (FRe) terá um novo layout, que facilitará a dinâmica de seu preenchimento, tornando-o mais responsivo.
      <br><br> Dessa forma, para reapresentações, o sistema direcionará, automaticamente, as informações já prestadas no referido quadro, constantes da última versão, para a nova estrutura.
      <br><br> Adicionalmente, a partir de 03/10/2026, o relatório completo do FRe apresentará uma nova formatação, inclusive, com índice remissivo.
      <br><br> Qualquer dúvida, nossa Superintendência de Atendimento de Listados está à disposição para auxiliar, pelo telefone (11) 2565-5063 ou por e-mail: <a class=\"link-external-b3\" href=\"mailto:emissores.empresas@b3.com.br\">emissores.empresas@b3.com.br</a>
      <br><br> Até breve,
      <br><br> Equipe B3 – Portfolio de Emissores e Ofertas.`,
      "expirationDate": "2026-10-19"
    }
  ];
  // .map((item, index) => ({
  //   ...item,
  //   id: index + 1,
  //   title: `Aviso ${(index + 1).toString().padStart(2, '0')} - ${item.title}`
  // }));

  get visibleNotifications(): any[] {
    return this.notificationItems.slice(0, 5);
  }

  get itemCount(): number {
    return this, this.notificationItems.length
  }

  get getNotifications(): any {
    return this.notificationItems;
  }

  constructor() {
    this.updateNotificationItems();
  }

  // Função para filtrar itens que ainda não expiraram e formatar os títulos
  private updateNotificationItems() {
    const currentDate = new Date(); // Data atual
    this.notificationItems = this.notificationItems
      .filter(item => new Date(item.expirationDate) >= currentDate) // Filtra itens que não expiraram
      .map((item, index) => ({
        ...item,
        id: index + 1, // Define o ID
        title: `Aviso ${(index + 1).toString().padStart(2, '0')} - ${item.title}` // Formata o título
      }));
  }

  getPaginatedNotifications(page: number): any[] {
    const startIndex = page * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.notificationItems.slice(startIndex, endIndex)
  }

  getTotalPages(): number {
    return Math.ceil(this.notificationItems.length / this.itemsPerPage);
  }

  setPage(page: number): void {
    if (page > 0 && page < this.getTotalPages()) {
      this.currentPage = page;
    }
  }

  getNotificationByIndex(index: number): any {
    return this.notificationItems[index];
  }

  getNotificationIndex(notification: any): number {
    return this.notificationItems.findIndex(item =>
      item.date === notification.date && item.title === notification.title
    );
  }
}
